import lastAlarmSignalsApi from "../../api/lastAlarmSignals";
import { formatDate } from "../../utils/dateTimeFormatter"

export default {
    state: {
        _lastAlarmSignals: []
    },
    getters: {
        lastAlarmSignals: state => state._lastAlarmSignals
            .map(el => ({
                    description: el.ZoneId && el.ZoneDescription ? el.ZoneId + ' - ' + el.ZoneDescription : el.ZoneDescription || el.ZoneId || '',
                    eventDate: formatDate(el.DateTime, "MM/DD/YYYY hh:mm:ss A"),
                    csNo: el.CsNo,
                    event: el.EventId && el.EventDescription ? el.EventId + ' - ' + el.EventDescription : el.EventDescription || el.EventId || '',
                    key: {
                        seqNo: el.SeqNo,
                        eventDate: el.DateTime,
                        systemId: el.SystemId
                    }
            })),
        alarmDetails: state => (seqNo, eventDate, systemId) => state._lastAlarmSignals
            .filter(el => el.SeqNo == seqNo && el.DateTime == eventDate && el.SystemId == systemId)
            .map(el => ({
                    eventDate: formatDate(el.DateTime, "MMM D, YYYY"),
                    eventTime: formatDate(el.DateTime, "hh:mm:ss A"),
                    csNo: el.CsNo,
                    event: el.EventId && el.EventDescription ? el.EventId + " - " + el.EventDescription : el.EventId || el.EventDescription,
                    zone: el.ZoneId && el.ZoneDescription ? el.ZoneId + " - " + el.ZoneDescription : el.ZoneId || el.ZoneDescription,
                    user: el.User,
                    area: el.Area,
                    match: el.Match,
                    rawSignal: el.RawSignal,
                    comment: el.Comment
            }))[0] || {}
    },
    mutations: {
        setlastAlarmSignals: (state, data) => state._lastAlarmSignals = data
    },
    actions: {
        async initLastAlarmSignals({ commit }) {
            let result = await lastAlarmSignalsApi.getLast100AlarmSignals();
            commit('setlastAlarmSignals', result);
        },
        async initLastAlarmSignalsDirty({ dispatch, state }) {
            if (state._lastAlarmSignals.length) {
                return;
            }
            await dispatch("initLastAlarmSignals");
        }
    }
}